<template>
  <div>
    <router-view />

    <!-- Показываем только если WS был подключен и потом отвалился -->
    <div v-if="wsManager.state.wasConnected && !wsManager.state.isConnected" class="pos-fixed pos-b-0 pos-l-0 pos-r-0 pd-small bg-warning t-center">
      <span>⚠️ Notification service disconnected.</span>
      <button class="mn-l-thin bg-none bd-none cursor-pointer t-main" @click="reconnect">Reconnect</button>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import wsManager from '@martyrs/src/modules/core/views/classes/ws.manager.js';

const store = inject('store');
const notificationManager = computed(() => store.notificationManager || null);

const reconnect = () => {
  if (notificationManager.value) {
    notificationManager.value.initialize();
  }
};
</script>